export default __webpack_public_path__ + "static/media/angpao-bg.421509df.webp";